<template>
  <div class="digitRoll-options-style"></div>
</template>

<script>
export default {
  name: "digitRoll-options-style",
  components: {},
  props: {},
  computed: {
    textStyles() {
      let menu =
        this.request_prefix === "bigScreen" ? this.$store.state.bigScreenMenu.menu : this.$store.state.menu.menu
      let styles = [],
        titleStyles = [],
        paragraphStyles = []
      for (let i = 0; i < menu.children.length; i++) {
        if (menu.children[i].type === "element") {
          for (let j = 0; j < menu.children[i].children.length; j++) {
            if (menu.children[i].children[j].type === "cxText") {
              styles = menu.children[i].children[j].children
              break
            }
          }
          break
        }
      }
      if (this.request_prefix === "bigScreen") {
        let bigScreenStyle = []
        styles.forEach((item, index) => {
          bigScreenStyle.push(item.attribute.options)
        })
        return bigScreenStyle
      }
      styles.forEach((item, index) => {
        if (item.attribute.options.textType === "title") {
          titleStyles.push(item.attribute.options)
        } else if (item.attribute.options.textType === "paragraph") {
          paragraphStyles.push(item.attribute.options)
        }
      })
      return { titleStyles, paragraphStyles }
    },
    showStyles() {
      return this.textStyles.length > this.showLen ? this.textStyles.slice(0, this.showLen) : this.textStyles
    },
    moreStyles() {
      return this.textStyles.length > this.showLen ? this.textStyles.slice(this.showLen) : []
    }
  },
  data() {
    return {
      activeTextIndex: undefined,
      activeType: undefined,
      activeIndex: undefined,
      titleStyles: [],
      paragraphStyles: [],
      activeNames: [],
      showLen: 6,
      styleImgs: [
        require("assets/images/leftMenu/text/text2.png"),
        require("assets/images/leftMenu/text/text1.png")
      ]
    }
  },
  methods: {
    changeTextStyle(style, index, type) {
      if (this.request_prefix !== "bigScreen") {
        this.activeTextIndex = index
        this.activeType = type
      } else {
        this.activeIndex = index
      }
      let tmpData = JSON.parse(JSON.stringify(style))
      let curOptions = this.$getOptions()
      tmpData.left = curOptions.left
      tmpData.top = curOptions.top
      tmpData.width = curOptions.width
      tmpData.height = curOptions.height
      tmpData.content = curOptions.content
      let ids = this.$store.state.states.activeID
      let data = {
        ...ids,
        options: tmpData
      }
      this.$store.dispatch(this.request_prefix + "/changeAllOptions", data)
    },
    computedStyle(style) {
      return {
        lineHeight: `${style.lineHeight}px`,
        fontSize: `${style.fontSize}px`,
        backgroundColor: style.bgColor,
        color: style.color,
        fontWeight: style.fontWeight,
        textAlign: style.textAlign,
        writingMode: style.writingMode,
        letterSpacing: style.letterSpacing + "px",
        textDecoration: style.textDecoration
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue-title {
  font-weight: normal;
  font-size: 14px;
  line-height: 28px;
  border-bottom: 1px solid;
}
.text-styles {
  p {
    margin-bottom: 0;
  }
  .text-style-item {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #e9e9e9;
    &.active {
      border: 1px solid var(--themeColor);
      box-shadow: 0 0 0 1px var(--themeColor);
    }
  }
  .text-item {
    width: 100%;
    border: none;
    padding: 0;
  }
}
.bigscreen-text-styles {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  p {
    margin-bottom: 0;
  }
  .text-img-box {
    padding: 8px 0;
    height: 60px;
    border-radius: 4px;
    border: 1px solid #3a3c3e;
    background: #1f2124;
    text-align: center;
    img {
      width: 60px;
    }
  }
  .text-style-item {
    width: calc((100% - 16px) / 3);
    box-sizing: border-box;
    margin: 0 8px 12px 0;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &.active {
      .text-img-box {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
      }
      p {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
  .text-item {
    width: 100%;
    border: none;
    padding: 0;
  }
}
</style>
